import { ConcernCausePart } from "./concern-cause-part";

export class ClaimsAppRequest {
    public contractNumber = "";
    public customerFirstName = "";
    public customerLastName = "";
    public vin = "";

    public breakdownDate: Date;
    public currentOdometer: number;
    public repairOrderNumber: "";

    public IsDrivenIn: boolean = false;
    public isCollision: boolean = false;
    public hasModification: boolean = false;
    public IsCommercialUse: boolean = false;
    
    public ConcernCauseComponents: ConcernCausePart[] = [];

    public contactId = "";
    public repairFacilityId = "";

    public repairFacilityName = "";
    public repairFacilityPhone = "";
    public repairFacilityBusinessEmail = "";
    public repairFacilityContactEmail = "";
    public repairFacilityContact = "";
    public repairFacilityPreferredContactMethod = ""
    
    public repairFacilityAddressLine1 = "";
    public repairFacilityAddressLine2 = "";
    public repairFacilityCity = "";
    public repairFacilityState = "";
    public repairFacilityZip = "";

    public repairFacilityLaborRatePerHour = "";
    public repairFacilityLaborManualUsed = "";
    public repairFacilityPreferredPayment = "";
}